import { Button } from "@loot-os/ui/components/button";
import * as Sentry from "@sentry/react";
import { type ErrorComponentProps, useRouter } from "@tanstack/react-router";
import { useEffect } from "react";

/** The router's default errorComponent: reports the render failure and offers one retry. */
export function RouteError({ error }: ErrorComponentProps) {
  const router = useRouter();
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);
  return (
    <div className="py-16 text-center">
      <h1 className="text-xl font-semibold">Something went wrong</h1>
      <div className="mt-4">
        <Button onClick={() => router.invalidate()}>Try again</Button>
      </div>
    </div>
  );
}
